import React from 'react';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10 relative overflow-hidden" data-id="element-138">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-139">
        <div ref={ref1} className={`reveal bg-[#2D1B1B] rounded-3xl p-8 md:p-12 border border-[#C9A96E]/20 shadow-[0_0_40px_rgba(201,169,110,0.1)] text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-140">
          <div className="w-20 h-20 bg-gradient-to-br from-[#C9A96E] to-[#C4856A] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-141">
            <span className="text-4xl text-[#1C1410]" data-id="element-142">🛡️</span>
          </div>

          <h2 className="text-2xl md:text-4xl font-bold text-[#F5ECD7] mb-6" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-143">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-[#FAF3E8] text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-144">
            <p data-id="element-145">Abrís los tomos. Los trabajás en tu práctica.</p>
            <p data-id="element-146">
              Si en 7 días no es lo que esperabas — devolución del 100%. Sin
              formularios. Sin drama. Sin culpa.
            </p>
            <p className="text-[#C9A96E] font-bold text-sm uppercase tracking-widest mt-6" data-id="element-147">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}